import React, { useState, useEffect } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import "./dashboard.css";
import DashboardHome from "./DashboardHome";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import payimg from "../assets/pay.png";
import contectimg from "../assets/contect.png";
import { selectervalues } from "../assets/data";
import Container from "@mui/material/Container";
import gzrimg from "../assets/gzr.png";
import termimg from "../assets/terms.png";
import bellimg from "../assets/bell.png";
import MenuIcon from "@mui/icons-material/Menu";
import logoimg from "../assets/logo.png";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useLocation } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { Link, useNavigate } from "react-router-dom";
import { useSnackbar } from "notistack";
import axios from "axios";
import Cookies from "js-cookie";
import Lottie from "react-lottie";
import { API_BASE_URL } from "../components/Config";
import { fetchPayment, fetchContact, fetchBoiler } from "../assets/data";
import animationData from "../assets/a1.json";

import { Box, Typography } from "@mui/material";
import {
  Faqsaccording1,
  Faqsaccording2,
  Faqsaccording3,
  Faqsaccording4,
  Faqsaccording5,
  Faqsaccording6,
  Faqsaccording7,
} from "../assets/data";

import { styled } from "@mui/material/styles";
import ArrowForwardIosSharpIcon from "@mui/icons-material/ArrowForwardIosSharp";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: "none",
  boxShadow: "none",
  "&:not(:last-child)": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon className="accordion_icon" />}
    {...props}
  />
))(({ theme }) => ({
  flexDirection: "row",
  padding: 0,
  backgroundColor: "transparent",
  "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
    transform: "rotate(180deg)",
  },
}));

const drawerWidth = 240;

const Dashboard = () => {
  const navigate = useNavigate();
  const [accountHolderName, setAccountHolderName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [sortCode, setSortCode] = useState("");
  const [firstName, setFirstName] = useState("");
  const [surname, setSurname] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [postCode, setPostCode] = useState("");
  const [address, setAddress] = useState("");
  const [boilerDetails, setBoilerDetails] = useState("");
  const match1990 = useMediaQuery("(max-width:850px)");
  const [mobileOpen, setMobileOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("Home");
  const location = useLocation();
  const { enqueueSnackbar } = useSnackbar();
  const [showAnimation, setShowAnimation] = useState(true);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  const resetPaymentFields = () => {
    setAccountHolderName("");
    setAccountNumber("");
    setSortCode("");
  };

  const resetContactFields = () => {
    setFirstName("");
    setSurname("");
    setEmail("");
    setPhoneNumber("");
    setPostCode("");
    setAddress("");
  };

  useEffect(() => {
    if (location.state && location.state.tab) {
      setActiveTab(location.state.tab);
    }

    const fetchData = async () => {
      try {
        const token = Cookies.get("token");
        let config = {
          method: "GET",
          url: `${API_BASE_URL}/customer/boiler/`,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };

        const response = await axios(config);
        console.log(response.data[0].value, "response");
        setBoilerDetails(response.data[0].value);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleDrawerToggle = async (tab) => {
    switch (tab) {
      case "payment":
        await fetchPayment(setAccountHolderName, setAccountNumber, setSortCode);
        break;
      case "contact":
        await fetchContact(
          setFirstName,
          setSurname,
          setEmail,
          setPhoneNumber,
          setPostCode,
          setAddress
        );
        break;
      default:
        break;
    }
    setMobileOpen(!mobileOpen);
  };

  useEffect(() => {
    const isAuthenticated = Cookies.get("token") !== undefined;
    if (!isAuthenticated) {
      navigate("/Login");
    }
    if (location.state && location.state.tab) {
      console.log(location.state, "lolol");
      console.log(location.state.tab, "lolol");
      setActiveTab(location.state.tab);
    }
    const timer = setTimeout(() => {
      setShowAnimation(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, [location]);

  if (showAnimation) {
    return (
      <div className="center-animation">
        <Lottie options={defaultOptions} height={400} width={400} />
      </div>
    );
  }

  const simulateAPIRequest = async (url, method, data) => {
    try {
      const token = Cookies.get("token");
      let config = {
        method,
        url,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };

      if (data && method !== "GET") {
        config.data = data;
      }

      const response = await axios(config);
      console.log(response, "response");
      return response.data;
    } catch (error) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        enqueueSnackbar(error.response.data.message, { variant: "error" });
      } else {
        enqueueSnackbar("An error occurred", { variant: "error" });
      }
      throw error;
    }
  };

  const handlePaymentCreate = async (
    accountHolderName,
    accountNumber,
    sortCode
  ) => {
    try {
      if (!accountHolderName || !accountNumber || !sortCode) {
        enqueueSnackbar("Please fill in all fields", { variant: "error" });
        return;
      }

      const url = `${API_BASE_URL}/customer/payment/`;

      const method = "POST";

      const data = {
        account_holder_name: accountHolderName,
        account_number: accountNumber,
        sort_code: sortCode,
      };

      try {
        await simulateAPIRequest(url, method, data);
        resetPaymentFields();
        enqueueSnackbar("Payment details saved successfully", {
          variant: "success",
        });
      } catch (error) {
        enqueueSnackbar("Failed to save payment details", { variant: "error" });
      }
    } catch (error) {
      enqueueSnackbar("An unexpected error occurred", { variant: "error" });
    }
  };

  const handleContactCreate = async (
    firstName,
    surname,
    email,
    phoneNumber,
    postCode,
    address
  ) => {
    if (
      !firstName ||
      !surname ||
      !email ||
      !phoneNumber ||
      !postCode ||
      !address
    ) {
      enqueueSnackbar("Please fill in all fields", { variant: "error" });
      return;
    }

    const url = `${API_BASE_URL}/customer/contact/`;
    const method = "POST";
    const data = {
      first_name: firstName,
      surname: surname,
      email: email,
      phone_number: phoneNumber,
      post_code: postCode,
      address: address,
    };

    try {
      await simulateAPIRequest(url, method, data);
      resetContactFields();
      enqueueSnackbar("Contact details saved successfully", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar("Failed to save contact details", { variant: "error" });
    }
  };

  const handleBoilerCreate = async () => {
    if (!boilerDetails) {
      enqueueSnackbar("Please select boiler details", { variant: "error" });
      return;
    }

    const url = `${API_BASE_URL}/customer/boiler/`;
    const method = "POST";
    const data = {
      value: boilerDetails,
    };

    try {
      await simulateAPIRequest(url, method, data);
      enqueueSnackbar("Boiler details saved successfully", {
        variant: "success",
      });
    } catch (error) {
      enqueueSnackbar("Failed to save Boiler details", { variant: "error" });
    }
  };

  const handleDocumentDownload = async () => {
    try {
      const url = `${API_BASE_URL}/customer/document/`;
      const response = await axios({
        method: "GET",
        url,
        responseType: "blob",
      });

      const contentDisposition = response.headers["content-disposition"];
      let filename = "WeCare.pdf";

      if (
        contentDisposition &&
        contentDisposition.indexOf("attachment") !== -1
      ) {
        const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        const matches = filenameRegex.exec(contentDisposition);
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, "");
        }
      }

      const blob = new Blob([response.data], {
        type: response.headers["content-type"],
      });
      const downloadUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", filename);
      document.body.appendChild(link);

      link.click();

      window.URL.revokeObjectURL(downloadUrl);
      document.body.removeChild(link);
    } catch (error) {
      console.error("Failed to download document:", error);
      enqueueSnackbar("Failed to download document", { variant: "error" });
    }
  };

  const handleAccountHolderNameChange = (e) => {
    setAccountHolderName(e.target.value);
  };

  const handleAccountNumberChange = (e) => {
    setAccountNumber(e.target.value);
  };

  const handleSortCodeChange = (e) => {
    setSortCode(e.target.value);
  };

  const handleFirstNameChange = (e) => {
    setFirstName(e.target.value);
  };

  const handleSurnameChange = (e) => {
    setSurname(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handlePhoneNumberChange = (e) => {
    setPhoneNumber(e.target.value);
  };

  const handlePostCodeChange = (e) => {
    setPostCode(e.target.value);
  };

  const handleAddressChange = (e) => {
    setAddress(e.target.value);
  };

  return (
    <>
      <div>
        <AppBar position="static" className="dashboard_nav">
          <Container maxWidth="xl" className="container_dashboard">
            <Toolbar className="flex_nav">
              <Link to="/">
                <h4>Dashboard</h4>
              </Link>
            </Toolbar>
          </Container>
        </AppBar>
      </div>

      <div className="dashbord">
        <Tabs
          selectedIndex={[
            "Home",
            "payment",
            "contact",
            "boiler",
            "Documents",
            "FAQs",
          ].indexOf(activeTab)}
        >
          <div
            className="box-shadows mobil_device"
            style={{ top: mobileOpen ? "47px" : "-350px" }}
          >
            <Container maxWidth="xl" className="container_dashboard">
              <TabList className="list_btn_dahboard">
                <Tab onClick={() => handleDrawerToggle("Home")}>
                  <Link
                    to="/dashboard"
                    state={{ tab: "Home" }}
                  >
                    Home
                  </Link>
                </Tab>
                <Tab onClick={() => handleDrawerToggle("payment")}>
                  <Link
                    to="/dashboard"
                    state={{ tab: "payment" }}
                  >
                    Payment Details
                  </Link>
                </Tab>
                <Tab onClick={() => handleDrawerToggle("contact")}>
                  <Link
                    to="/dashboard"
                    state={{ tab: "contact" }}
                  >
                    Contact Details
                  </Link>
                </Tab>
                
                <Tab onClick={() => handleDrawerToggle("boiler")}>
                  <Link
                    to="/dashboard"
                    state={{ tab: "boiler" }}
                  >
                    Boiler Details
                  </Link>
                </Tab>
                <Tab onClick={() => handleDrawerToggle("Documents")}>
                  <Link
                    to="/dashboard"
                    state={{ tab: "Documents" }}
                  >
                    Documents
                  </Link>
                </Tab>
                <Tab onClick={() => handleDrawerToggle("FAQs")}>
                  <Link
                    to="/dashboard"
                    state={{ tab: "FAQs" }}
                  >
                    FAQs
                  </Link>
                </Tab>
            
               
                
              </TabList>
            </Container>
          </div>

          <Container maxWidth="xl" className="container_dashboard">
            <TabPanel>
              <DashboardHome />
            </TabPanel>
            <TabPanel>
              <div className="dashboard_details_page">
                <div className="detail_div_dashbord">
                  <h1>Details</h1>
                  <p>Update your payment details here</p>
                </div>
                <div className="box_one_find">
                  <div className="check_stp1">
                    <div className="flex-div-dashborad">
                      {" "}
                      <h1>Payment Details</h1>
                      <img src={payimg} alt="payments" className="img_dashs" />
                    </div>
                    <form className="form_dabits">
                      <div>
                        <label className="contact_detail_label" htmlFor="1">
                          Name of Account Holder
                        </label>
                        <input
                          type="text"
                          id="1"
                          value={accountHolderName}
                          placeholder="First Name"
                          onChange={handleAccountHolderNameChange}
                        />
                      </div>
                      <div>
                        <label className="contact_detail_label" htmlFor="2">
                          Bank Account Number
                        </label>
                        <input
                          type="text"
                          placeholder="Bank Account Number"
                          id="2"
                          value={accountNumber}
                          onChange={handleAccountNumberChange}
                        />
                      </div>
                      <div>
                        <label className="contact_detail_label" htmlFor="3">
                          Sort Code
                        </label>
                        <input
                          type="text"
                          placeholder="Sort Code"
                          id="3"
                          value={sortCode}
                          onChange={handleSortCodeChange}
                        />
                      </div>
                      <Button
                        variant="contained"
                        className="paymint_btn "
                        onClick={() =>
                          handlePaymentCreate(
                            accountHolderName,
                            accountNumber,
                            sortCode
                          )
                        }
                      >
                        Save Changes
                      </Button>
                    </form>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="dashboard_details_page">
                <div className="detail_div_dashbord">
                  <h1>Details</h1>
                  <p>Update your Contact details here</p>
                </div>
                <div className="box_one_find">
                  <div className="check_stp1">
                    <div className="flex-div-dashborad">
                      <h1>Contact Detail</h1>
                      <img src={contectimg} alt="icons" className="img_dashs" />
                    </div>
                    <form className="form_dabits">
                      <div>
                        <label className="contact_detail_label" htmlFor="1">
                          First Name*
                        </label>
                        <input
                          type="text"
                          id="1"
                          placeholder="First Name"
                          value={firstName}
                          onChange={handleFirstNameChange}
                        />
                      </div>
                      <div>
                        <label className="contact_detail_label" htmlFor="2">
                          SurName*
                        </label>
                        <input
                          type="text"
                          placeholder="SurName"
                          id="2"
                          value={surname}
                          onChange={handleSurnameChange}
                        />
                      </div>
                      <div>
                        <label className="contact_detail_label" htmlFor="3">
                          Email Address*
                        </label>
                        <input
                          type="email"
                          placeholder="Email Address"
                          id="3"
                          value={email}
                          onChange={handleEmailChange}
                        />
                      </div>
                      <div>
                        <label className="contact_detail_label" htmlFor="4">
                          Phone Number*
                        </label>
                        <input
                          type="number"
                          placeholder="Phone Number"
                          id="4"
                          value={phoneNumber}
                          onChange={handlePhoneNumberChange}
                        />
                      </div>
                      <div>
                        <label className="contact_detail_label" htmlFor="4">
                          Post Code*
                        </label>
                        <input
                          type="text"
                          placeholder="Post Code"
                          id="4"
                          value={postCode}
                          onChange={handlePostCodeChange}
                        />
                      </div>
                      <div>
                        <label className="contact_detail_label" htmlFor="6">
                          Enter Your Address Manually*
                        </label>
                        <input
                          type="text"
                          placeholder="Enter Your Address"
                          id="6"
                          value={address}
                          onChange={handleAddressChange}
                        />
                      </div>
                      <Button
                        variant="contained"
                        className="paymint_btn "
                        onClick={() =>
                          handleContactCreate(
                            firstName,
                            surname,
                            email,
                            phoneNumber,
                            postCode,
                            address
                          )
                        }
                      >
                        Save Changes
                      </Button>
                    </form>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="dashboard_details_page">
                <div className="detail_div_dashbord">
                  <h1>Details</h1>
                  <p>Update your boiler details here</p>
                </div>
                <div
                  className="box_one_find"
                  style={{ maxWidth: "600px", width: "100%" }}
                >
                  <div className="flex-div-dashborad selected_det">
                    <h4>Boiler Details</h4>
                    <img src={gzrimg} alt="icons" className="img_dashs" />
                  </div>
                  <select
                    className="celect_dabid form-select"
                    value={boilerDetails}
                    onChange={(event) => setBoilerDetails(event.target.value)}
                  >
                    {selectervalues.map((item, i) => (
                      <option key={i} value={item.values}>
                        {item.values}
                      </option>
                    ))}
                  </select>

                  <div className="BoilerSaveBtnDiv">
                    <Button
                      variant="contained"
                      className="BoilerSaveBtn"
                      onClick={handleBoilerCreate}
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="dashboard_details_page">
                <div className="detail_div_dashbord">
                  <h1>Documents</h1>
                  <p>Download your WeCare documents here</p>
                </div>
                <div
                  className="box_one_find"
                  style={{ maxWidth: "600px", width: "100%" }}
                >
                  <div className="flex-div-dashborad selected_det">
                    <h4>Terms of Service</h4>
                    <img src={termimg} alt="icons" className="img_dashs" />
                  </div>
                  <Button
                    variant="contained"
                    className="paymint_btn "
                    onClick={handleDocumentDownload}
                  >
                    Download
                  </Button>
                </div>
              </div>
            </TabPanel>
            <TabPanel>
              <div className="dashboard_details_page">
                <div>
                <Box className="faqBoxsec">
                    <Typography variant="h4" fontWeight={600}>FAQs</Typography>
                    <Typography variant="body1" >
                        Welcome to <span className='wecare_faq_span'>WeCare’s </span>boiler care FAQs section! Here, we aim to address  common questions and <br />concerns you may have about boiler  maintenance, troubleshooting, and repairs.
                    </Typography>
                </Box>
                  <Box className="acorionswth">
                    <Typography variant="h3" className="joincol">
                      Joining Wecare
                    </Typography>
                    {Faqsaccording1.map((item, i) => (
                      <Accordion className="accordionBox helpaccordion" key={i}>
                        <AccordionSummary>
                          <Typography className="faq_title">
                            {item.title}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ padding: 0 }}>
                          <Typography className="faq_desc">
                            {item.desc}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    ))}
                  </Box>
                  <Box className="acorionswth">
                    <Typography variant="h3" className="joincol">
                      About My Boiler
                    </Typography>
                    {Faqsaccording2.map((item, i) => (
                      <Accordion
                        className="dashboard_faq_section accordionBox helpaccordion"
                        key={i}
                      >
                        <AccordionSummary>
                          <Typography className="faq_title">
                            {item.title}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ padding: 0 }}>
                          <Typography className="faq_desc">
                            {item.desc}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    ))}
                  </Box>
                  <Box className="acorionswth">
                    <Typography variant="h3" className="joincol">
                      Boiler Servicing
                    </Typography>
                    {Faqsaccording3.map((item, i) => (
                      <Accordion
                        className="dashboard_faq_section accordionBox helpaccordion"
                        key={i}
                      >
                        <AccordionSummary>
                          <Typography className="faq_title">
                            {item.title}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ padding: 0 }}>
                          <Typography className="faq_desc">
                            {item.desc}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    ))}
                  </Box>
                  <Box className="acorionswth">
                    <Typography variant="h3" className="joincol">
                      Pricing & Payments
                    </Typography>
                    {Faqsaccording4.map((item, i) => (
                      <Accordion
                        className="dashboard_faq_section accordionBox helpaccordion"
                        key={i}
                      >
                        <AccordionSummary>
                          <Typography className="faq_title">
                            {item.title}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ padding: 0 }}>
                          <Typography className="faq_desc">
                            {item.desc}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    ))}
                  </Box>
                  <Box className="acorionswth">
                    <Typography variant="h3" className="joincol">
                      To Book a Repair
                    </Typography>
                    {Faqsaccording5.map((item, i) => (
                      <Accordion
                        className="dashboard_faq_section accordionBox helpaccordion"
                        key={i}
                      >
                        <AccordionSummary>
                          <Typography className="faq_title">
                            {item.title}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ padding: 0 }}>
                          <Typography className="faq_desc">
                            {item.desc}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    ))}
                  </Box>
                  <Box className="acorionswth">
                    <Typography variant="h3" className="joincol">
                      Coverage
                    </Typography>
                    {Faqsaccording6.map((item, i) => (
                      <Accordion
                        className="dashboard_faq_section accordionBox helpaccordion"
                        key={i}
                      >
                        <AccordionSummary>
                          <Typography className="faq_title">
                            {item.title}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ padding: 0 }}>
                          <Typography className="faq_desc">
                            {item.desc}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    ))}
                  </Box>
                  <Box className="acorionswth">
                    <Typography variant="h3" className="joincol">
                      Existing Customers
                    </Typography>
                    {Faqsaccording7.map((item, i) => (
                      <Accordion
                        className="dashboard_faq_section accordionBox helpaccordion"
                        key={i}
                      >
                        <AccordionSummary>
                          <Typography className="faq_title">
                            {item.title}
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ padding: 0 }}>
                          <Typography className="faq_desc">
                            {item.desc}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    ))}
                  </Box>
                </div>
              </div>
            </TabPanel>
          </Container>
        </Tabs>
      </div>
    </>
  );
};

export default Dashboard;
